import React, { FC, useEffect, useLayoutEffect, useState } from "react";
import Layout from "../Layout";
import { Box, Paper, Menu, MenuItem } from "@material-ui/core";
import { useStyles, CustomCheckbox } from "./style";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import {
  getPaymentModesByMerchantId,
  initLazyPayPayment,
  savePaymentInfo,
  updateStoreCredits,
  completePaymentAction,
  verifyGstForPurchase,
} from "../../Redux/Actions";
import {
  GST_INFO_SYMBOL,
  VERIFY_GST_API_ACTIONS,
  GST_STATES,
  EDIT_GST_ICON,
  REMOVE_GST_ICON,
  UPDATE_GST_OPTIONS,
  VAILD_GST_REGEX,
} from "./constants";
import { RootState } from "../../Redux/Reducers";
import BackArrow from "../../Assets/images/return.png";
import GPayLogo from "../../Assets/images/gpay-logo.png";
import PaytmLogo from "../../Assets/images/paytm-logo.png";
import PhonePeLogo from "../../Assets/images/phonepe-logo.png";
import LazyPayLogo from "../../Assets/images/lazypay_.png";
import { PremiumHeader, PremiumBody } from "../../Components";
import QRPaymentComponent from "@/Components/QRPaymentComponent";
import CardPaymentBox from "@/Components/CardPaymentBox";
import EMIPaymentBox from "@/Components/EMIPaymentBox";
import LazyPayAuth from "@/Components/LazyPayAuth";
import VisaLogo from "../../Assets/images/visa-logo.png";
import MastercardLogo from "../../Assets/images/mastercard-logo.png";
import WalletIcon from "../../Assets/images/ic-wallet.png";
import "./style.scss";
import { CURRENT_CURRENCY_SYMBOL, GST_STATUS, PREMIUM_PURCHASE_TYPE_CONSTANTS, TRANSACTION_ID } from "../../Constants";
import { getPremiumPurchaseType } from "../../Utils/_helper";
import LocalStorageHelper from "../../Utils/LocalStorageHelper";
import dsLogo from "../../Assets/images/logo-with-name-white.png";
import { SOURCE_DS_LANDING } from "../DomainSalesSearch/utils/constant";
import { ToastNotifyError } from "../../Components/Toast";
import DiscountStrip from "./DiscountStrip";

const Payment: FC<any> = (props: any): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [state, setState] = useState<any>({
    selectedOption: "",
    creditsUsed: undefined,
    isCreditUsed: false,
    showUserCreditBox: false,
    isCallInitiateApi: true,
    showLayout: false,
  });

  const [gstStatus, setGstStatus] = useState(GST_STATES.ADD);
  const [showInvalidGstError, setShowInvalidGstError] = useState(false);
  const [showUpdateGstMenu, setShowUpdateGstMenu] = useState(false);
  const [currentGstNumber, setCurrentGstNumber] = useState("");

  const { prePaymentData, activePaymentMethods, storeInfo, userCredits } = useSelector((state: RootState) => ({
    prePaymentData: state.paymentMethodReducer.prePaymentData,
    activePaymentMethods: state.paymentMethodReducer.activePaymentMethods,
    storeInfo: state.storeReducer.store,
    userCredits: state.creditEngine.userCredits,
  }));

  useLayoutEffect(() => {
    if (sessionStorage.getItem("premiumPurchaseType") === PREMIUM_PURCHASE_TYPE_CONSTANTS.DOMAIN_MARKETING) {
      setState((st) => ({ ...st, showLayout: false }));
    } else {
      setState((st) => ({ ...st, showLayout: true }));
    }
  }, []);

  /**
   * if txnId key value pair is in local storag, remove it
   */
  useEffect(() => {
    if (LocalStorageHelper.get(TRANSACTION_ID)) {
      LocalStorageHelper.delete(TRANSACTION_ID);
    }
    dispatch(
      verifyGstForPurchase(
        {
          subscription_payment_id: prePaymentData?.subscription_payment_id,
          action_type: VERIFY_GST_API_ACTIONS.ADD,
        },
        (status: boolean, gstNumber: string) => {
          if (status) {
            if (gstNumber.length > 0) {
              setCurrentGstNumber(gstNumber);
              setGstStatus(GST_STATES.SAVED);
            }
          } else {
            setGstStatus(GST_STATES.ACTIVE);
          }
        },
      ),
    );
  }, []);

  useEffect(() => {
    if (prePaymentData.amount) {
      dispatch(
        getPaymentModesByMerchantId({
          id: 2,
          amount: prePaymentData.amount,
        }),
      );
    }
    // if payment amount is more than Rs 1 lakh then switch to CARD payment
    if (prePaymentData.amount >= 100000) {
      changePaymentType("CARD");
    }
    if (
      getPremiumPurchaseType() !== PREMIUM_PURCHASE_TYPE_CONSTANTS.CREDIT_ENGINE &&
      storeInfo?.owner?.permissions?.includes(4)
    ) {
      setState((state: any) => ({
        ...state,
        creditsUsed: prePaymentData.credit_used,
        isCreditUsed: !!prePaymentData.credit_used,
        selectedOption: getInitiallySelectedOption(),
        showUserCreditBox: true,
        isCallInitiateApi: true,
      }));
    } else {
      setState({ ...state, selectedOption: "UPI" });
    }
  }, [prePaymentData.amount]);

  /**
   * This section of code is to make sure if user 
   is coming to payement page from DS landing 
   page then left side bar will not appear
   */

  const sourceParam = new URLSearchParams(window.location.search);
  const sourceParamValue = sourceParam.get("source");
  const IS_DS_LANDING_PAGE = sourceParamValue === SOURCE_DS_LANDING;

  useEffect(() => {
    if (IS_DS_LANDING_PAGE) {
      setState((prevStates) => ({ ...prevStates, showLayout: false }));
    }
  }, [window.location.search]);

  function updateGSTNumber(gst: string) {
    const reg = VAILD_GST_REGEX;
    if (reg.test(gst)) {
      ToastNotifyError("Only Alphanumeric input is allowed");
      return;
    }
    setCurrentGstNumber(gst);
  }

  function getInitiallySelectedOption() {
    if (state.selectedOption && !prePaymentData.credit_used) {
      return state.selectedOption;
    } else if (prePaymentData.credit_used && !prePaymentData.amount) {
      return "credits";
    }
    return "UPI";
  }

  function getPayAmount() {
    return prePaymentData.amount;
  }

  function toggleInitiatePaymentApiState() {
    setState((state: any) => ({
      ...state,
      isCallInitiateApi: !state.isCallInitiateApi,
    }));
  }

  const onClickGoBack = () => {
    if (props?.location?.state?.adId) {
      props.history.replace("/marketing/ad/step/1", { adId: props.location?.state?.adId });
    } else {
      props.history.goBack();
    }
  };

  const changePaymentType = (val: string) => {
    const currentCreditsUsed = isPayAmountLessThanCredits() ? 0 : state.creditsUsed;
    if (val === "LAZYPAY") {
      const payload: any = {
        orderID: prePaymentData?.orderID,
        paymentMethod: "lazyPay",
        merchantID: prePaymentData?.merchantID,
        // deviceType: getDeviceInfo().OSName,
        // browserType: getDeviceInfo().BrowserName,
        // userAgent: getDeviceInfo().userAgent,
        source: "premium",
        merchantName: `Web Console - ${storeInfo?.store_info?.name}`,
      };

      dispatch(savePaymentInfo(payload));

      payload.phone = prePaymentData.phone;
      payload.amount = prePaymentData.amount;
      payload.store_id = prePaymentData.storeID;
      payload.credit_used = state.creditsUsed;
      dispatch(initLazyPayPayment(payload));
    }
    setState((state: any) => ({
      ...state,
      selectedOption: val,
      isCreditUsed: isPayAmountLessThanCredits() ? !state.isCreditUsed : state.isCreditUsed,
      creditsUsed: currentCreditsUsed,
    }));
    if (isPayAmountLessThanCredits()) {
      callUpdateStoreCredits(currentCreditsUsed);
    }
  };

  function callUpdateStoreCredits(creditsToBeUsed: any) {
    dispatch(
      updateStoreCredits(
        {
          credits: parseInt(creditsToBeUsed),
          subscription_payment_id: prePaymentData?.subscription_payment_id,
        },
        () => {
          toggleInitiatePaymentApiState();
        },
      ),
    );
  }

  /**
   * If amount is less then the credits then user can use all credits or no credits
   */
  function isPayAmountLessThanCredits() {
    return !prePaymentData?.amount;
  }

  /**
   * This function will be called when user clicks on the credits box and there will be 2 cases
   * 1. When the amount is less than the credits then the credits remains selected
   * 2. If amount is greater than the credits the user might check/uncheck the box
   */
  function onCreditBoxClick() {
    const currentCreditsUsed = state.isCreditUsed ? 0 : getCreditsUsed(); // on the previous state of the checkbox we are setting the credtis to be used
    if (!isPayAmountLessThanCredits()) {
      setState((state: any) => ({
        ...state,
        creditsUsed: currentCreditsUsed,
        isCreditUsed: !state.isCreditUsed,
      }));
    } else {
      setState({ ...state, selectedOption: "credits" });
    }
    callUpdateStoreCredits(currentCreditsUsed);
  }

  /**
   * function return payment amount strip
   * @returns {JSX}
   */
  const _renderPaymentAmtStrip = (): JSX.Element => {
    return <article className="pv3 bg-black-10 fw6 f4 tc">Pay ₹ {getPayAmount()}</article>;
  };

  /**
   * Function check which payment option
   * is checked and return thier view
   * @param {String} type
   * @returns {JSX}
   */
  const _renderPaymentBlock = (type: string): JSX.Element | undefined => {
    switch (type) {
      case "UPI":
        return (
          <div className={state.selectedOption === "UPI" ? "db" : "dn"}>
            {_renderPaymentAmtStrip()}
            <QRPaymentComponent
              toggleInitiatePaymentApiState={toggleInitiatePaymentApiState}
              isCallInitiateApi={state.isCallInitiateApi}
            />
          </div>
        );
      case "CARD":
        return (
          <div className={state.selectedOption === "CARD" ? "db" : "dn"}>
            <CardPaymentBox
              paymentAmount={getPayAmount()}
              toggleInitiatePaymentApiState={toggleInitiatePaymentApiState}
              isCallInitiateApi={state.isCallInitiateApi}
            />
          </div>
        );
      case "LAZYPAY": {
        return (
          <div className={state.selectedOption === "LAZYPAY" ? "db" : "dn"}>
            {_renderPaymentAmtStrip()}
            <LazyPayAuth
              toggleInitiatePaymentApiState={toggleInitiatePaymentApiState}
              isCallInitiateApi={state.isCallInitiateApi}
              selectedOption={state.selectedOption}
            />
          </div>
        );
      }
      case "EMI": {
        return (
          <div className={state.selectedOption === "EMI" ? "db" : "dn"}>
            <EMIPaymentBox
              paymentAmount={getPayAmount()}
              toggleInitiatePaymentApiState={toggleInitiatePaymentApiState}
              isCallInitiateApi={state.isCallInitiateApi}
              isDesktop={true}
            />
          </div>
        );
      }
    }
  };

  const _renderPaymentMode = ({
    title,
    option,
    images,
  }: {
    title: string;
    option: string;
    images: any[];
    hasImages: boolean;
  }): JSX.Element => 
    <Box
      component="section"
      className={classes.paymentOption}
      style={{
        borderColor: state.selectedOption === option ? "#3A8E0D" : "#BABABA",
        backgroundColor: state.selectedOption === option ? "#FCFFFA" : "#FFFFFF",
      }}
      onClick={() => changePaymentType(option)}
    >
      <Box className={classes.leftSection}>
        <div
          style={{
            borderColor: state.selectedOption === option ? "#3A8E0D" : "#000000",
          }}
          className={classes.radioButton}
        >
          <span
            style={{
              backgroundColor: state.selectedOption === option ? "#3A8E0D" : "transparent",
            }}
            className={classes.radioButtonInner}
          />
        </div>
      </Box>
      <Box className={classes.rightSection}>
        <p className={classes.paymentOptionTitle}>{title}</p>

        <Box>
          {images.map((image: { height: number; imgSrc: string | undefined }) => 
            <span className={classes.paymentTypesBox} style={option === "LAZYPAY" ? { width: 118 } : {}}>
              <img
                height={image.height}
                src={image.imgSrc}
                className={option === "LAZYPAY" ? classes.lazypayImage : ""}
              />
            </span>,
          )}
        </Box>
      </Box>
    </Box>
  ;
  function getCreditsUsed() {
    if (isShowCreditCheckBox()) {
      return prePaymentData.credit_used || userCredits;
    }
    return prePaymentData.credit_used || prePaymentData.amount;
  }

  function isShowCreditCheckBox() {
    if (prePaymentData.amount) {
      if (!prePaymentData.credit_used && userCredits > prePaymentData.amount) {
        return false;
      }
      return true;
    }
    return false;
  }

  function _renderUserCreditsBox() {
    return (
      <Box
        component="section"
        className={classes.paymentOption}
        style={{
          borderColor: state.creditsUsed ? "#3A8E0D" : "#BABABA",
          backgroundColor: state.creditsUsed ? "#FCFFFA" : "#FFFFFF",
        }}
        onClick={onCreditBoxClick}
      >
        <Box className={classes.leftSection}>
          {isShowCreditCheckBox() ? 
            <CustomCheckbox checked={state.isCreditUsed} inputProps={{ "aria-labelledby": "credits" }} />
           : 
            <div
              style={{
                borderColor: state.creditsUsed ? "#3A8E0D" : "#000000",
              }}
              className={classes.radioButton}
            >
              <span
                style={{
                  backgroundColor: state.creditsUsed ? "#3A8E0D" : "transparent",
                }}
                className={classes.radioButtonInner}
              />
            </div>
          }
        </Box>
        <Box className={classes.rightSection}>
          <div className={classes.paymentOptionTitle}>
            Use{" "}
            <b>
              {CURRENT_CURRENCY_SYMBOL}
              {getCreditsUsed()}
            </b>{" "}
            from Dotpe Credits
          </div>
          <div className="md-text14 md-f400 ds-c8D8D8D ds-mt8">
            Available Credit: {CURRENT_CURRENCY_SYMBOL}
            {userCredits}
          </div>
        </Box>
      </Box>
    );
  }

  function _renderCreditOptionBox() {
    return (
      <div className="credit-pay-box flex flex-column justify-between">
        <div className="flex items-start justify-between">
          <div className="flex flex-column">
            <div className="md-text25 b">
              Pay {CURRENT_CURRENCY_SYMBOL}
              {prePaymentData.credit_used}
            </div>
            <div className="md-text14 md-f400 ds-c8D8D8D">
              This amount will be deducted from <br></br>your Dotpe Credits
            </div>
          </div>
          <img src={WalletIcon} alt=""></img>
        </div>
        <button
          className="md-text18 md-f700 w-100 br-30 br-none primary-cta flex items-center justify-center"
          onClick={() => {
            dispatch(
              completePaymentAction({
                order_id: prePaymentData.orderID,
                subscription_payment_id: prePaymentData.subscription_payment_id,
              }),
            );
          }}
        >
          PAY {CURRENT_CURRENCY_SYMBOL}
          {prePaymentData.credit_used}
        </button>
      </div>
    );
  }

  function _renderUpdateGstNumberMenu() {
    return (
      <div className="update-menu pointer">
        <div className="edit-gst-number" onClick={() => handleUpdateBtn(UPDATE_GST_OPTIONS.EDIT)}>
          <img className="edit-gst-number-icon" src={EDIT_GST_ICON} alt="Edit GST Number" />
          <p className="edit-gst-number-text">Edit number</p>
        </div>
        <div className="remove-gst-number pointer" onClick={() => handleUpdateBtn(UPDATE_GST_OPTIONS.REMOVE)}>
          <img className="remove-gst-number-icon" src={REMOVE_GST_ICON} alt="Remove GST Number" />
          <p className="remove-gst-number-text">Remove</p>
        </div>
      </div>
    );
  }

  function handleSaveChangeBtn() {
    if (gstStatus === GST_STATES.SAVED) {
      setShowUpdateGstMenu(!showUpdateGstMenu);
    } else if (gstStatus === GST_STATES.ACTIVE) {
      setShowInvalidGstError(false);
      dispatch(
        verifyGstForPurchase(
          {
            subscription_payment_id: prePaymentData?.subscription_payment_id,
            action_type: VERIFY_GST_API_ACTIONS.UPDATE,
            gst_number: currentGstNumber,
          },
          (status: boolean, gstNumber: string) => {
            if (status) {
              if (gstNumber.length > 0) {
                setCurrentGstNumber(gstNumber);
                setGstStatus(GST_STATES.SAVED);
              }
            } else {
              setGstStatus(GST_STATES.ACTIVE);
              setShowInvalidGstError(true);
            }
          },
        ),
      );
    }
  }

  function handleUpdateBtn(type: number) {
    if (gstStatus === GST_STATES.SAVED) {
      if (type === UPDATE_GST_OPTIONS.EDIT) {
        setGstStatus(GST_STATES.ACTIVE);
      } else if (type === UPDATE_GST_OPTIONS.REMOVE) {
        dispatch(
          verifyGstForPurchase(
            {
              subscription_payment_id: prePaymentData?.subscription_payment_id,
              action_type: VERIFY_GST_API_ACTIONS.REMOVE,
            },
            (status: boolean, gstNumber: string) => {
              setGstStatus(GST_STATES.ACTIVE);
              setCurrentGstNumber("");
            },
          ),
        );
      }
      setShowUpdateGstMenu(false);
    }
  }

  function handleAddGstBtn() {
    setGstStatus(GST_STATES.ACTIVE);
  }

  const _Children = () => {
    return (
      <>
        {/* {state.showLayout ? ( */}
        <PremiumHeader noAlertbar fullWidth={!!IS_DS_LANDING_PAGE}>
          {state.showLayout ? 
            <span className="f4 fw6 flex items-center">
              <img src={BackArrow} width="34" height="34" className="mr3 pointer" onClick={onClickGoBack} />
              Payment
            </span>
           : 
            <Box className={`bb b--black-10 pt4 ph4 open-payment-header`}>
              <div className="flex items-center w-100">
                <Box className="ds-logo-wrapper self-start relative">
                  <img src={dsLogo} className="ds-logo" />
                </Box>
              </div>
            </Box>
          }
        </PremiumHeader>
        {/* // ) : (
        //   <Box className={`bb b--black-10 pv4 ph4 open-payment-header`}>
        //     <div className="flex items-center w-100">
        //       <Box className="ds-logo-wrapper self-start relative">
        //         <img src={dsLogo} className="ds-logo" />
        //       </Box>
        //     </div>
        //   </Box>
        // )} */}
        <PremiumBody>
          <Box className={classes.paymentBody}>
            <div className="payment-side-bar">
              {gstStatus == GST_STATES.ADD ? 
                <div className="gst-container-add">
                  <div className="gst-header">
                    <p className="gst-header-text">Do you have a GST number?</p>
                    <div className="gst-add-btn pointer" onClick={handleAddGstBtn}>
                      <p className="gst-add-btn-text">Add GSTIN</p>
                    </div>
                  </div>
                  <div className="gst-info">
                    <img className="gst-info-icon" src={GST_INFO_SYMBOL} />
                    <p className="gst-info-text">
                      If you don’t add a GST number, your invoice will be generated without it
                    </p>
                  </div>
                </div>
               : 
                <div className="gst-container">
                  <div className="gst-header-input">
                    <div className="gst-header">
                      <h3 className="gst-header-text">GSTIN</h3>
                      <div className="gst-header-optional">
                        <p className="gst-header-optional-text">OPTIONAL</p>
                      </div>
                    </div>
                    <div className={`input-container ${gstStatus === GST_STATES.SAVED ? "input-saved" : ""}`}>
                      <input
                        className={`gst-input`}
                        key="gst-input"
                        id="gst-input"
                        type="text"
                        placeholder="Enter GST Number"
                        maxLength={15}
                        onChange={(e) => updateGSTNumber(e.target.value)}
                        value={currentGstNumber}
                        disabled={gstStatus === GST_STATES.SAVED}
                      />
                      <label
                        htmlFor="gst-input"
                        className={`update-btn pointer ${currentGstNumber.length == 15 ? "update-enabled" : ""} ${gstStatus === GST_STATES.SAVED ? "update-saved" : ""}`}
                        onClick={handleSaveChangeBtn}
                      >
                        {gstStatus === GST_STATES.SAVED ? "Change" : currentGstNumber.length > 0 ? "Save" : ""}
                      </label>
                    </div>
                    {showInvalidGstError && <div className="invalid-gst-error">Please enter a valid GST number</div>}
                  </div>
                  <div className="gst-info">
                    <img className="gst-info-icon" src={GST_INFO_SYMBOL} />
                    <p className="gst-info-text">
                      {gstStatus === GST_STATES.SAVED
                        ? "Invoices once generated will not be changed"
                        : "If you don’t add a GST number, your invoice will be generated without it"}
                    </p>
                  </div>
                </div>
              }
              {gstStatus == GST_STATES.SAVED && showUpdateGstMenu && _renderUpdateGstNumberMenu()}

              <Box className={clsx("pa4")}>
                <p className={classes.asideHeader}>Select payment method</p>
                {/* Show UPI payment for payments for less than 1Lakh */}
                {state.showUserCreditBox &&
                  (userCredits ? 
                    _renderUserCreditsBox()
                   : 
                    <div className="no-user-credits-box flex items-center op5 pointer-none ds-p16 ds-mb20">
                      <div className="radio-btn ds-mr16"></div>
                      <div className="md-text16 md-f400">No Dotpe credits available</div>
                    </div>
                  )}
                {state.isCreditUsed && isShowCreditCheckBox() ? 
                  <div className="md-text16 md-f400 ds-mb12">
                    Pay remaining{" "}
                    <b>
                      {CURRENT_CURRENCY_SYMBOL}
                      {getPayAmount()}
                    </b>{" "}
                    with
                  </div>
                 : null}
                {prePaymentData?.amount < 100000 &&
                  _renderPaymentMode({
                    title: "UPI Payments",
                    option: "UPI",
                    hasImages: true,
                    images: [
                      {
                        imgSrc: PaytmLogo,
                        height: 21,
                      },
                      {
                        imgSrc: GPayLogo,
                        height: 23,
                      },
                      {
                        imgSrc: PhonePeLogo,
                        height: 24,
                      },
                    ],
                  })}
                {_renderPaymentMode({
                  title: "Credit & Debit Cards",
                  option: "CARD",
                  hasImages: true,
                  images: [
                    {
                      imgSrc: MastercardLogo,
                      height: 29,
                    },
                    {
                      imgSrc: VisaLogo,
                      height: 44,
                    },
                  ],
                })}
                {activePaymentMethods?.includes("cemi") &&
                  _renderPaymentMode({
                    title: "EMI",
                    option: "EMI",
                    hasImages: true,
                    images: [
                      {
                        imgSrc: MastercardLogo,
                        height: 29,
                      },
                      {
                        imgSrc: VisaLogo,
                        height: 44,
                      },
                    ],
                  })}
                {activePaymentMethods?.includes("lazyPay") &&
                  _renderPaymentMode({
                    title: "Lazypay",
                    option: "LAZYPAY",
                    hasImages: true,
                    images: [
                      {
                        imgSrc: LazyPayLogo,
                        height: 44,
                      },
                    ],
                  })}
              </Box>
            </div>

            <Box className={`${classes.paymentMain} tw-pt-8`}>
              <div className="tw-flex tw-w-full tw-justify-center">
                <DiscountStrip discount={prePaymentData?.discount} />
              </div>
              <Box display="flex" justifyContent="center" className="pb4 ph3">
                <Paper
                  className={
                    state.selectedOption === "EMI" ? `${classes.paymentInner} EMI-paper-box` : `${classes.paymentInner}`
                  }
                >
                  {/* Show UPI payment for payments for less than 1Lakh */}
                  {prePaymentData?.amount < 100000 && _renderPaymentBlock("UPI")}
                  {_renderPaymentBlock("CARD")}
                  {_renderPaymentBlock("LAZYPAY")}
                  {_renderPaymentBlock("EMI")}
                  {state.selectedOption === "credits" && _renderCreditOptionBox()}
                </Paper>
              </Box>
            </Box>
          </Box>
        </PremiumBody>
      </>
    );
  };

  return state.showLayout ? <Layout activeTabIndex={0}>{_Children()}</Layout> : _Children();
};

export default Payment;
